export function donemFromDate(iso: string) {
  const label = new Date(`${iso}T00:00:00`).toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' })
  return label.charAt(0).toLocaleUpperCase('tr') + label.slice(1)
}

export function periodKey(iso: string) {
  return iso.slice(0, 7)
}
